import { render, staticRenderFns } from "./SimplifiedSplashDesktop.vue?vue&type=template&id=638bc6ee"
import script from "./SimplifiedSplashDesktop.vue?vue&type=script&lang=js"
export * from "./SimplifiedSplashDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports